import { Chakra } from "@airhelp/react-ui-components";
import { LIGHT_SHADOW } from "modules/storyblok/templates/AirHelpScore/styles";
import type { TopThreeCardProps } from "./TopThreeCard.d";

const { Flex } = Chakra;

const TopThreeCard = ({ children }: TopThreeCardProps) => (
  <Flex
    py={10}
    px={8}
    rounded="xl"
    borderColor="greyscale.400"
    bg="white"
    boxShadow={LIGHT_SHADOW}
    textAlign="center"
    flexDir="column"
    justifyContent="space-between"
  >
    {children}
  </Flex>
);

export default TopThreeCard;
